import moment from "moment";

const dateTimeFormat = (date) => {
    if (date) {
        return moment(date).format("DD.MM.YYYY HH:mm");
    }
    return "-";
}

export const stringToDateTime = (date) => {
    //2024-01-10T00:00:00.000 string to date
    if (date) {
        return new Date(date);
    }
    return null;
}
export default dateTimeFormat;
